module.exports = __webpack_public_path__ + "img/desktop_cover_b.3442d28d.png";